/** Presentation-only selectors. Every identifier is checked against resolved content by its consumer. */
export type PublicCompositionLocation = {
  section?: string;
  timeline?: string;
  floor?: string;
  capture?: string;
  before?: string;
  after?: string;
  view?: "list" | "scrubber" | "compare";
};
const keys = ["section", "timeline", "floor", "capture", "before", "after", "view"] as const;
const identifier = /^[a-zA-Z0-9_-]{1,128}$/;
export function parsePublicCompositionLocation(hash: string): PublicCompositionLocation {
  if (hash.length > 2048) return {};
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const value: PublicCompositionLocation = {};
  for (const key of keys) {
    const part = params.get(key);
    if (!part) continue;
    if (key === "view") {
      if (part === "list" || part === "scrubber" || part === "compare") value.view = part;
    } else if (identifier.test(part)) value[key] = part;
  }
  // Existing hand-authored section anchors remain valid.
  if (!value.section && /^#vs-section-[a-zA-Z0-9_-]{1,128}$/.test(hash)) value.section = hash.slice(12);
  return value;
}
export function encodePublicCompositionLocation(value: PublicCompositionLocation): string {
  const params = new URLSearchParams();
  for (const key of keys) if (value[key]) params.set(key, value[key]!);
  const valid = parsePublicCompositionLocation(params.toString());
  const safe = new URLSearchParams();
  for (const key of keys) if (valid[key]) safe.set(key, valid[key]!);
  return safe.size ? `#${safe}` : "";
}
